$(window).on("load" , function(){
  $(".mega-menu__content").removeClass("d-none");
})

$(document).ready(function () {
  // var _highestBox = 0;
  // $(".card__heading ").removeAttr("style");
  // $(".card__heading ").each(function () {
  //     if ($(this).height() > _highestBox) {
  //         _highestBox = $(this).height();
  //     }
  // });
  // $(".card__heading ").css("height", _highestBox);

  $(".menu-opening").click(function () {
      $(this).find(".menu3 ").slideToggle();
      $(this).parents(".menu-drawer__menu li").siblings().find(".menu3 ").slideUp();
      $(this).find(".rotet_svg").toggleClass("active");
      $(this).parents(".menu-drawer__menu li").siblings().find(".rotet_svg").removeClass("active");
  });

  $(document).on("click", ".menu-drawer__close-button", function (e) {
      $(this).parent().find(".menu3").slideUp();
      $(this).parent().find(".rotet_svg").removeClass("active");
  });

  var $slider = $('.a_product__media-list');
  var $slider2 = $('.a_product__media-list li' );
  
  if ($slider2.length  > 1) {
    var currentSlide;
    var slidesCount;
    var sliderCounter = document.createElement('div');
    sliderCounter.classList.add('slider__counter');
    
    var updateSliderCounter = function(slick, currentIndex) {
      currentSlide = slick.slickCurrentSlide() + 1;
      slidesCount = slick.slideCount;
      $(sliderCounter).text(currentSlide + '/' +slidesCount)
    };
  
    $slider.on('init', function(event, slick) {
      $slider.append(sliderCounter);
      updateSliderCounter(slick);
    });
  
    $slider.on('afterChange', function(event, slick, currentSlide) {
      updateSliderCounter(slick, currentSlide);
    });
  
    $(".a_product__media-list").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,  
      asNavFor: ".ul-thumbnail-list",
      responsive: [
        {
          breakpoint: 752,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1,
             dots: true
          }
        }
      ]
    });
  }
  
  $(".ul-thumbnail-list").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: ".a_product__media-list",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1160,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 4,
          slidesToScroll:1
        }
      }
    ]
  });
  
$(".cart_like_ul").slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll:1
      }
    },
     {
      breakpoint: 578,
      settings: {
        slidesToShow: 1,
        slidesToScroll:1
      }
    }
  ]
}).on('setPosition', function (event, slick) { 
      equl(".cart_like-text h2")
     equl(".cart_like_inner")
});

$(".tab_heading").on("click" , function(){
  $(this).parents(".pro_tab_content").toggleClass("active").find(".par_inne_desctiption").slideToggle().parents(".pro_tab_content").siblings().removeClass("active").find(".par_inne_desctiption").slideUp();
})

$(document).ready(function() {
  var $slider = $('.drawercart_like_ul');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
     infinite: true,
    arrows: false,
    speed: 400
  }).on('setPosition', function (event, slick) { 
    equl(".drawercart_like-text h2")
  });
});

  $(".mobile-facets__header-inner").click(function(){
    $(".mobile-facets__close").trigger("click")
  })
  
  $(document).on("click " , ".mobile-facets__summary" , function(){
    $(this).parents(".mobile-facets__details").find(".mobile-facets__list").slideToggle();
    $(this).toggleClass("rotet_active") 
  })
// $(document).on("click" , ".mobile-facets__open-wrapper" , function(){
//   $(".section-header").addClass("shopify-section-header-sticky animate")
// })


  $(window).on("load" , function(){
    function mtfunc(){
      $(".th_wl_button").parents(".add_wistlist").find(".wish_text").show();
      $(".th_wl_button_after").parents(".add_wistlist").find(".go_wish_text").show();
      $(".th_wl_button").parents(".add_wistlist").find(".go_wish_text").hide();
      $(".th_wl_button_after").parents(".add_wistlist").find(".wish_text").hide();
    }
    setTimeout(mtfunc , 1000)
  })  

  $(document).on("click" , ".th_wl_button" , function(){
    $(".wish_text").hide();
    $(".go_wish_text").show();
  })
  
  $(document).on("click" , ".th_wl_button_after " , function(){
    $(".wish_text").show();
    $(".go_wish_text").hide();
  })

});


// equal height JS

function equalHeight(){
  var largest = 0;
  $(".home_collection_list .slider_text h3").each(function(){
    var findHeight = $(this).outerHeight();
    if(findHeight > largest){
      largest = findHeight;
    }  
  });
  $(".home_collection_list .slider_text h3").css({"height": largest +"px","display": "block" });
}

$(document).ready(function(){
  equalHeight();
})

$(window).resize(function(){
  equalHeight();
})

function equl(name ){ 
    var heading = document.querySelectorAll(name);
    var titleHeight = 0;
    heading.forEach((title) => {
        var matchHeight = title.clientHeight;
        if (matchHeight > titleHeight) {
            titleHeight = title.clientHeight;
        }
    });
    heading.forEach((divHeight) => {
        divHeight.style.minHeight = titleHeight + "px";
    });
}
// equl(".pro_prices")
// equl(".product_variants")
equl(".cate_inner h3")
equl(".about_text_grid_inner  .content")
equl(".about_text_grid_inner   .content")
